export default "__VITE_ASSET__3dde3be5__"